import React from "react";

import { ProposalLayout } from "../../../types/proposalDocuments.types";

interface LayoutPreviewProps {
  layout: ProposalLayout;
}

const SupplierDrivenPreview: React.FC = () => (
  <div className="gp-preview gp-preview--supplier">
    <style>{`
      .gp-preview--supplier {
        --gp-primary-teal: #1ea7ac;
        --gp-primary-black: #1d1d1b;
        --gp-primary-teal-20: #d3eef0;

        display: inline-block;
        max-width: 480px;
        width: 100%;
        padding: 1.5rem;
        border-radius: 0.5rem;
        background: #11151a;
        box-sizing: border-box;
      }

      .gp-preview--supplier * {
        box-sizing: border-box;
      }

      .gp-preview--supplier .gp-title {
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 0.05em;
        color: white;
        font-size: 1.3em;
        margin: 0 0 0.6em;
      }

      .gp-preview--supplier .gp-group {
        background-color: var(--gp-primary-black);
        padding: 0.5em;
        border-radius: 4px;
      }

      .gp-preview--supplier .gp-group-heading {
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-size: 0.9em;
        font-weight: 600;
        color: var(--gp-primary-teal-20);
        padding: 0.25em 0.5em;
        margin: 0;
      }

      .gp-preview--supplier table {
        width: 100%;
        border-collapse: collapse;
        background: transparent;
        table-layout: fixed;
      }

      .gp-preview--supplier th,
      .gp-preview--supplier td {
        padding: 0.5rem 0.6rem;
        font-size: 0.72em;
        text-align: left;
        vertical-align: top;
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: #ffffff;
      }

      .gp-preview--supplier th {
        color: rgba(255, 255, 255, 0.5);
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.65em;
        border-bottom: 2px solid rgba(255, 255, 255, 0.4);
      }

      .gp-preview--supplier th:nth-child(1),
      .gp-preview--supplier td:nth-child(1) {
        width: 40%;
      }

      .gp-preview--supplier th:nth-child(2),
      .gp-preview--supplier td:nth-child(2),
      .gp-preview--supplier th:nth-child(3),
      .gp-preview--supplier td:nth-child(3),
      .gp-preview--supplier th:nth-child(4),
      .gp-preview--supplier td:nth-child(4) {
        width: 20%;
      }
    `}</style>

    <p className="gp-title">Summary of your quote</p>
    <div className="gp-group">
      <h3 className="gp-group-heading">Electric</h3>
      <table>
        <thead>
          <tr>
            <th>Company</th>
            <th>Term</th>
            <th>AQ</th>
            <th>Annual Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Current</td>
            <td>Rolling</td>
            <td>45,000.0 Units</td>
            <td>£6,000.00</td>
          </tr>
          <tr>
            <td>Scottish Power</td>
            <td>12 Months</td>
            <td>45,000.0 Units</td>
            <td>£5,000.00</td>
          </tr>
          <tr>
            <td>EDF Business</td>
            <td>24 Months</td>
            <td>45,000.0 Units</td>
            <td>£5,200.00</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

const ComparisonDrivenPreview: React.FC = () => (
  <div className="gp-preview gp-preview--comparison">
    <style>{`
      .gp-preview--comparison {
        --gp-primary-teal: #1ea7ac;
        --gp-primary-black: #1d1d1b;
        --gp-primary-teal-20: #d3eef0;
        --gp-negative: #e2574c;

        display: inline-block;
        max-width: 480px;
        width: 100%;
        padding: 1.5rem;
        border-radius: 0.5rem;
        background: #11151a;
        box-sizing: border-box;
      }

      .gp-preview--comparison * {
        box-sizing: border-box;
      }

      .gp-preview--comparison .gp-title {
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 0.05em;
        color: white;
        font-size: 1.3em;
        margin: 0 0 0.6em;
      }

      .gp-preview--comparison .gp-group {
        background-color: var(--gp-primary-black);
        padding: 0.5em;
        border-radius: 4px;
      }

      .gp-preview--comparison .gp-group-heading {
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-size: 0.9em;
        font-weight: 600;
        color: var(--gp-primary-teal-20);
        padding: 0.25em 0.5em;
        margin: 0;
      }

      .gp-preview--comparison table {
        width: 100%;
        border-collapse: collapse;
        background: transparent;
        table-layout: fixed;
      }

      .gp-preview--comparison th,
      .gp-preview--comparison td {
        padding: 0.5rem 0.6rem;
        font-size: 0.72em;
        text-align: left;
        vertical-align: top;
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: #ffffff;
      }

      .gp-preview--comparison th {
        color: rgba(255, 255, 255, 0.5);
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.65em;
        border-bottom: 2px solid rgba(255, 255, 255, 0.4);
      }

      .gp-preview--comparison th:nth-child(1),
      .gp-preview--comparison td:nth-child(1) {
        width: 16%;
      }

      .gp-preview--comparison th:nth-child(2),
      .gp-preview--comparison td:nth-child(2) {
        width: 24%;
      }

      .gp-preview--comparison th:nth-child(3),
      .gp-preview--comparison td:nth-child(3) {
        width: 12%;
      }

      .gp-preview--comparison th:nth-child(4),
      .gp-preview--comparison td:nth-child(4) {
        width: 20%;
      }

      .gp-preview--comparison th:nth-child(5),
      .gp-preview--comparison td:nth-child(5) {
        width: 28%;
      }

      .gp-preview--comparison .gp-cost-cell {
        text-align: right;
      }

      .gp-preview--comparison .gp-cost-value {
        font-weight: 700;
      }

      .gp-preview--comparison .gp-saving,
      .gp-preview--comparison .gp-increase {
        display: block;
        font-size: 0.85em;
        margin-top: 0.15rem;
      }

      .gp-preview--comparison .gp-saving {
        color: var(--gp-primary-teal);
      }

      .gp-preview--comparison .gp-increase {
        color: var(--gp-negative);
      }
    `}</style>

    <p className="gp-title">Summary of your quote</p>
    <div className="gp-group">
      <h3 className="gp-group-heading">Electric</h3>
      <table>
        <thead>
          <tr>
            <th>Meter</th>
            <th>Company</th>
            <th>Term</th>
            <th>AQ</th>
            <th>Annual Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1234</td>
            <td>Scottish Power</td>
            <td>12 Months</td>
            <td>45,000.0 Units</td>
            <td className="gp-cost-cell">
              <span className="gp-cost-value">£5,000.00</span>
              <span className="gp-saving">£1,000.00</span>
            </td>
          </tr>
          <tr>
            <td>1234</td>
            <td>EDF Business</td>
            <td>24 Months</td>
            <td>45,000.0 Units</td>
            <td className="gp-cost-cell">
              <span className="gp-cost-value">£5,200.00</span>
              <span className="gp-saving">£800.00</span>
            </td>
          </tr>
          <tr>
            <td>2222</td>
            <td>Scottish Power</td>
            <td>12 Months</td>
            <td>45,000.0 Units</td>
            <td className="gp-cost-cell">
              <span className="gp-cost-value">£4,800.00</span>
              <span className="gp-increase">-£300.00</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

const LAYOUT_PREVIEW_COMPONENT: Record<ProposalLayout, React.FC> = {
  supplier: SupplierDrivenPreview,
  comparison: ComparisonDrivenPreview,
};

// Stub-turned-real mini-preview of how the generated document will be laid
// out for the given layout.
const LayoutPreview: React.FC<LayoutPreviewProps> = ({ layout }) => {
  const Preview = LAYOUT_PREVIEW_COMPONENT[layout];
  return (
    <div className="layout-preview" aria-hidden="true">
      <Preview />
    </div>
  );
};

export default LayoutPreview;
